module.exports = __webpack_public_path__ + "img/mobile-spectrum-Manufactruers.dd0ef9bf.png";